//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import commonload from "@/pcpage/hr/common/commonload";

export default {
    extends : commonload,
    name: "offerprocesstaxtable",
    components: {

    },
    data() {
        return {
            activeName: 'first',
            editItems: '',
        }
    },
    methods: {
        async init() {
            this.initParam();
        },

        initParam() {
            this.loadAddAction = "api/api/findTaxAndContribution";
        },

        handleClick(tab) {
            
        },

        doLoadRecordBefore: function (oQuery, reuestParams) {
            oQuery.record.year = reuestParams.year;
            return true;
        },

        async doLoadRecordAfter(oQuery, data){
            this.calculate();
        },

        async calculate() {
            let SSSContribution = this.record.SSSContribution;
            if(SSSContribution.length > 0) {
                for (let i = 0; i < SSSContribution.length; i++) {
                    let creditcompensation = 0;
                    if(SSSContribution[i].creditcompensation) {
                        creditcompensation = this.cal.accAdd(SSSContribution[i].creditcompensation, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'creditcompensation', creditcompensation);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'creditcompensation', '-');
                    }

                    let creditfund = 0;
                    if(SSSContribution[i].creditfund) {
                        creditfund = this.cal.accAdd(SSSContribution[i].creditfund, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'creditfund', creditfund);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'creditfund', '-');
                    }

                    let credittotal = this.cal.accAdd(creditcompensation, creditfund).toFixed(2);
                    if(credittotal == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'credittotal', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'credittotal', credittotal);
                    }

                    let securityer = 0;
                    if(SSSContribution[i].securityer) {
                        securityer = this.cal.accAdd(SSSContribution[i].securityer, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'securityer', securityer);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'securityer', '-');
                    }

                    let securityee = 0;
                    if(SSSContribution[i].securityee) {
                        securityee = this.cal.accAdd(SSSContribution[i].securityee, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'securityee', securityee);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'securityee', '-');
                    }

                    let securitytotal = this.cal.accAdd(securityer, securityee).toFixed(2);
                    if(securitytotal == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'securitytotal', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'securitytotal', securitytotal);
                    }

                    let compensationer = 0;
                    if(SSSContribution[i].compensationer) {
                        compensationer = this.cal.accAdd(SSSContribution[i].compensationer, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'compensationer', compensationer);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'compensationer', '-');
                    }

                    let compensationee = 0;
                    if(SSSContribution[i].compensationee) {
                        compensationee = this.cal.accAdd(SSSContribution[i].compensationee, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'compensationee', compensationee);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'compensationee', '-');
                    }

                    let compensationtotal = this.cal.accAdd(compensationer, compensationee).toFixed(2);
                    if(compensationtotal == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'compensationtotal', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'compensationtotal', compensationtotal);
                    }

                    let funder = 0;
                    if(SSSContribution[i].funder) {
                        funder = this.cal.accAdd(SSSContribution[i].funder, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'funder', funder);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'funder', '-');
                    }

                    let fundee = 0;
                    if(SSSContribution[i].fundee) {
                        fundee = this.cal.accAdd(SSSContribution[i].fundee, 0).toFixed(2);
                        this.$set(this.record.SSSContribution[i], 'fundee', funder);
                    } else {
                        this.$set(this.record.SSSContribution[i], 'fundee', '-');
                    }

                    let fundtotal = this.cal.accAdd(funder, fundee).toFixed(2);
                    if(fundtotal == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'fundtotal', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'fundtotal', fundtotal);
                    }

                    let totaler = this.cal.accAdd(this.cal.accAdd(securityer, compensationer), funder).toFixed(2);
                    if(totaler == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'totaler', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'totaler', totaler);
                    }
                    let totalee = this.cal.accAdd(this.cal.accAdd(securityee, compensationee), fundee).toFixed(2);
                    if(totalee == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'totalee', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'totalee', totalee);
                    }
                    let total = this.cal.accAdd(totaler, totalee).toFixed(2);
                    if(total == 0.00) {
                        this.$set(this.record.SSSContribution[i], 'total', '-');
                    } else {
                        this.$set(this.record.SSSContribution[i], 'total', total);
                    }
                }
            }
            let healthContribution = this.record.healthContribution;
            if(healthContribution.length > 0) {
                for (let i = 0; i < healthContribution.length; i++) {
                    let premiumstart;
                    let premiumend;
                    let rate = 0;
                    if(healthContribution[i].rate) {
                        rate = healthContribution[i].rate;
                    }
                    let salarybegin = 0;
                    if(healthContribution[i].salarybegin) {
                        salarybegin = healthContribution[i].salarybegin;
                        premiumstart = this.cal.accMul(this.cal.accMul(salarybegin, rate), 0.01).toFixed(2);
                    }
                    let salaryend = 0;
                    if(healthContribution[i].salaryend) {
                        salaryend = healthContribution[i].salaryend;
                        premiumend = this.cal.accMul(this.cal.accMul(salaryend, rate), 0.01).toFixed(2);
                    }
                    if(premiumstart && premiumend) {
                        this.$set(this.record.healthContribution[i], 'premium', premiumstart + ' - ' + premiumend);
                    } else {
                        if(premiumstart) {
                            this.$set(this.record.healthContribution[i], 'premium', premiumstart);
                        } else {
                            this.$set(this.record.healthContribution[i], 'premium', premiumend);
                        }
                    }
                }
            }
        },
    },
    created() {
        this.init().then(() => {
            this.doLoadRecordNot4Flow();
        });
    },
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/offerprocesstaxtable.vue